function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("rect", {
  width: 32,
  height: 32,
  rx: 16,
  fill: "#29354C"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M13.5 11.934v8.132a.5.5 0 00.777.416l6.099-4.066a.5.5 0 000-.832l-6.099-4.066a.5.5 0 00-.777.416z",
  stroke: "#fff",
  strokeWidth: 2
});

var SvgIconBubbleVideo = function SvgIconBubbleVideo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none"
  }, props), _ref, _ref2);
};

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIHZpZXdCb3g9IjAgMCAzMiAzMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3Qgd2lkdGg9IjMyIiBoZWlnaHQ9IjMyIiByeD0iMTYiIGZpbGw9IiMyOTM1NEMiLz4KPHBhdGggZD0iTTEzLjUgMTEuOTM0M1YyMC4wNjU3QzEzLjUgMjAuNDY1MSAxMy45NDUxIDIwLjcwMzMgMTQuMjc3MyAyMC40ODE4TDIwLjM3NiAxNi40MTZDMjAuNjcyOCAxNi4yMTgxIDIwLjY3MjggMTUuNzgxOSAyMC4zNzYgMTUuNTg0TDE0LjI3NzQgMTEuNTE4MkMxMy45NDUxIDExLjI5NjcgMTMuNSAxMS41MzQ5IDEzLjUgMTEuOTM0M1oiIHN0cm9rZT0id2hpdGUiIHN0cm9rZS13aWR0aD0iMiIvPgo8L3N2Zz4K";
export { SvgIconBubbleVideo as ReactComponent };